import type { ResolvedWidgetConfig } from "../config";

/** 忽略查询串、锚点和尾斜线；变体切换不是换商品。 */
export function pagePath(): string {
  return location.pathname.replace(/\/+$/, "") || "/";
}

/** 只消费宿主注入的 Shopify 商品字段，不猜测主题结构或请求商品接口。 */
export function createProductContextReader(
  container: HTMLElement,
  config: ResolvedWidgetConfig,
) {
  let product = config.productContext;
  let productPath = pagePath();
  let injectedId = product?.id;
  return () => {
    const data = container.dataset;
    if (data.productId !== undefined) {
      if (data.productId !== injectedId) {
        injectedId = data.productId;
        productPath = pagePath();
      }
      product = data.productId.trim()
        ? {
            id: data.productId,
            title: data.productTitle ?? "",
            url: productPath,
            variantId: data.variantId,
          }
        : undefined;
    }
    if (!product || productPath !== pagePath()) return undefined;
    return {
      ...product,
      variantId:
        new URL(location.href).searchParams.get("variant") ?? product.variantId,
    };
  };
}
